<script setup>
// Campo "se o contato já tem conversa aberta": seletor dos modos
// (aguardar/nova/enviar/não enviar) + editor da janela de horário quando 'hold'. Reusado
// pelo wizard (CampaignFinish) e pelo builder (node Conversa aberta).
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import ReleaseWindowEditor from './ReleaseWindowEditor.vue';

const props = defineProps({
  mode: {
    type: String,
    default: 'hold',
  },
  releaseWindow: {
    type: Array,
    default: null,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  // Modos que não devem ser oferecidos. Se o modo atual estiver na lista
  // (ex.: rascunho antigo), ele continua visível — esconder a seleção ativa
  // deixaria o estado real do node invisível.
  hiddenModes: {
    type: Array,
    default: () => [],
  },
});

const emit = defineEmits(['update:mode', 'update:releaseWindow']);

const { t } = useI18n();

const MODES = [
  {
    value: 'hold',
    icon: 'i-lucide-clock',
    label: 'MODE_HOLD',
    hint: 'MODE_HOLD_HINT',
  },
  {
    value: 'new',
    icon: 'i-lucide-message-square-plus',
    label: 'MODE_NEW',
    hint: 'MODE_NEW_HINT',
  },
  {
    value: 'send',
    icon: 'i-lucide-send',
    label: 'MODE_SEND',
    hint: 'MODE_SEND_HINT',
  },
  {
    value: 'skip',
    icon: 'i-lucide-ban',
    label: 'MODE_SKIP',
    hint: 'MODE_SKIP_HINT',
  },
];

const visibleModes = computed(() =>
  MODES.filter(
    option =>
      !props.hiddenModes.includes(option.value) || option.value === props.mode
  )
);

const key = suffix => `CAMPAIGN.WHATSAPP_OFFICIAL.OPEN_CONVERSATION.${suffix}`;
</script>

<template>
  <div class="flex flex-col gap-3">
    <div class="flex flex-col gap-2">
      <button
        v-for="option in visibleModes"
        :key="option.value"
        type="button"
        :disabled="disabled"
        class="w-full p-0 text-left"
        @click="emit('update:mode', option.value)"
      >
        <span
          class="flex items-start gap-2 rounded-lg border border-solid px-3 py-2 transition-colors"
          :class="
            mode === option.value
              ? 'border-n-green-8 bg-n-green-3 ring-1 ring-n-green-8'
              : 'border-n-weak bg-n-background hover:border-n-slate-8 hover:bg-n-alpha-1'
          "
        >
          <span
            class="mt-0.5 size-4 shrink-0"
            :class="[
              option.icon,
              mode === option.value ? 'text-n-green-11' : 'text-n-slate-10',
            ]"
          />
          <span class="min-w-0">
            <span class="block text-sm font-medium text-n-slate-12">
              {{ t(key(option.label)) }}
            </span>
            <span class="block text-xs text-n-slate-10">
              {{ t(key(option.hint)) }}
            </span>
          </span>
        </span>
      </button>
    </div>

    <div
      v-if="mode === 'hold'"
      class="flex flex-col gap-2 rounded-lg border border-solid border-n-weak bg-n-alpha-1 p-3"
    >
      <div>
        <h5
          class="text-[11px] font-semibold uppercase tracking-wide text-n-slate-10"
        >
          {{ t(key('WINDOW_TITLE')) }}
        </h5>
        <p class="text-xs text-n-slate-10">{{ t(key('WINDOW_HINT')) }}</p>
      </div>
      <ReleaseWindowEditor
        :model-value="releaseWindow"
        :disabled="disabled"
        @update:model-value="value => emit('update:releaseWindow', value)"
      />
    </div>
  </div>
</template>
